<script>
import { page } from '@/api/general/geOperLog'
export default {
  name: 'GeOperLogDrawer',
  components: {},
  props: {
    businessId: {
      type: [Number, String],
      default: null
    },
    businessSubId1: {
      type: Number,
      required: false,
      default: null
    },
    businessSubId2: {
      type: Number,
      required: false,
      default: null
    },
    businessSubId3: {
      type: Number,
      required: false,
      default: null
    },
    businessSubId4: {
      type: Number,
      required: false,
      default: null
    },
    // 参考：$enums.OPER_LOG_TYPE.[].value
    businessType: {
      type: Number,
      required: true
    },
  },
  data() {
    return {
      show: false,

      loading: false,
      list: [],
      total: 0,

      queryParams: {
        page: 1,
        size: 20,
        sort: [
          'create_time,desc'
        ]
      },
    };
  },
  computed: {

  },
  watch: {},
  mounted() {

  },
  methods: {
    open() {
      Object.assign(this.$data, this.$options.data())
      this.show = true
      this.onQuery()
    },
    onQuery() {
      this.loading = true
      const params = {
        ...this.queryParams,
        businessId: this.businessId,
        businessSubId1: this.businessSubId1,
        businessSubId2: this.businessSubId2,
        businessSubId3: this.businessSubId3,
        businessSubId4: this.businessSubId4,
        businessType: this.businessType
      }
      page(params).then(res => {
        this.list = res.data.records
        this.total = res.data.total
      }).finally(() => {
        this.loading = false
      })
    },
  }
}
</script>

<template>
  <el-drawer
    title="操作日志"
    :visible.sync="show"
    size="900px"
  >
    <div class="padding">
      <vxe-table
        border
        resizable
        show-overflow
        ref="table"
        :loading="loading"
        :data="list"
        :row-config="{isHover: true}"
      >
        <vxe-column type="seq" width="50" fixed="left"></vxe-column>
        <vxe-column
          field="title"
          title="操作"
          :visible="true"
          min-width="150"
        >
        </vxe-column>
        <vxe-column
          field="operDesc"
          title="说明"
          :visible="true"
          min-width="400"
        >
        </vxe-column>
        <!-- <vxe-column
          field="remark"
          title="备注"
          :visible="true"
          min-width="100"
        >
        </vxe-column> -->
        <vxe-column
          field="createByName"
          title="操作人"
          :visible="true"
          min-width="80"
        >
        </vxe-column>
        <vxe-column
          field="createTime"
          title="操作时间"
          :visible="true"
          min-width="140"
        >
        </vxe-column>
      </vxe-table>
      <pagination
        :total="total"
        :page.sync="queryParams.page"
        :limit.sync="queryParams.size"
        @pagination="onQuery"
      />
    </div>
  </el-drawer>
</template>

<style lang="scss" scoped>

</style>
